var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoGalacticMenuIconFaded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 109 107",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-0.173065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "matrix(1,0,0,0.958073,-110.596,-55.1506)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.596,
    y: 57.564,
    width: 359.524,
    height: 111.484,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.596,
    y: 57.564,
    width: 359.524,
    height: 111.484
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_icon_faded",
    transform: "matrix(1,0,0,1.04259,110.386,57.929)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.209,
    y: -0.177,
    width: 108.956,
    height: 107.109,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01053,0,0,1.01167,-111.985,-62.8465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.337,71.411L141.267,71.411C130.343,71.411 121.488,80.266 121.488,91.19L121.488,158.259L188.406,158.259C199.413,158.259 208.337,149.336 208.337,138.329L208.337,71.411Z",
    style: {
      fill: "none",
      stroke: "rgb(127,127,127)",
      strokeWidth: "11.87px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.00112,0.209397,-1.3511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.437,36.369C78.437,33.056 75.751,30.369 72.437,30.369L34.69,30.369C31.376,30.369 28.69,33.056 28.69,36.369L28.69,74.117C28.69,77.43 31.376,80.117 34.69,80.117L72.437,80.117C75.751,80.117 78.437,77.43 78.437,74.117L78.437,36.369ZM54.114,30.369L55.651,48.007L59.28,44.562L58.474,49.176L66.593,43.212L60.635,51.337L65.094,51.104L61.804,54.16L78.437,55.815L61.804,57.216L65.293,60.36L60.635,60.039L65.752,68.391L58.474,62.199L59.307,66.942L55.651,63.369L54.307,80.117L52.595,63.369L49.458,66.777L49.772,62.199L42.087,67.708L47.612,60.039L43.101,60.12L46.442,57.216L28.69,55.512L46.442,54.16L42.768,51.081L47.612,51.337L41.32,43.625L49.772,49.176L48.908,44.411L52.595,48.007L54.114,30.369Z",
    style: {
      fill: "rgb(127,127,127)"
    }
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGalacticMenuIconFaded);
export default __webpack_public_path__ + "static/media/logo_galactic_menu_icon_faded.91c79f4b.svg";
export { ForwardRef as ReactComponent };